// Mesón · fase 1: insignia del ESTADO DE PAGO de una nota (recibos de caja). La ve todo el proceso:
// nota, despacho y documento. Solo pinta lo que informa el backend (`GET /caja/notas/:id/pago`).
import type { PagoNota } from '../api/contratos';
import { pesos } from './formato';

export function EstadoPago({ pago }: { pago: PagoNota | undefined }) {
  if (!pago) return null;
  const aplicado = Number(pago.aplicado) > 0;
  const titulo = [
    `Total ${pesos(pago.total)} · pagado ${pesos(pago.pagado)} · saldo ${pesos(pago.saldo)}`,
    ...pago.recibos
      .filter((r) => r.estado === 'VIGENTE')
      .map((r) => `${r.numeroVisible} ${pesos(r.total)}`),
    aplicado ? `Aplicado al documento tributario: ${pesos(pago.aplicado)}` : '',
  ]
    .filter(Boolean)
    .join('\n');
  if (pago.estado === 'SIN_PAGO')
    return (
      <span className="insignia tono-neutro" data-pago="SIN_PAGO" title={titulo}>
        sin pago
      </span>
    );
  if (pago.estado === 'PARCIAL')
    return (
      <span className="insignia tono-aviso" data-pago="PARCIAL" title={titulo}>
        pago parcial {pesos(pago.pagado)} · saldo {pesos(pago.saldo)}
      </span>
    );
  return (
    <span className="insignia tono-ok" data-pago="PAGADA" title={titulo}>
      {aplicado ? 'pagada · aplicada' : 'pagada por adelantado'}
    </span>
  );
}
